import React from 'react'
import { X } from 'react-feather'
import { useViewport } from '../../utils'
import { GalleryItem } from './gallery-item'

const RemoveButton = (props) => {
  return (
    <div
      className="bg-white rounded-full p-1 absolute right-0 top-0 my-1 mx-3 cursor-pointer"
      {...props}
    >
      <X width="12px" height="12px" />
    </div>
  )
}

/**
 *
 * @param {Array} items
 * Array of image blobs
 */
const GalleryDropzonePreview = ({
  items = [],
  onRemove = (index) => {console.log(index)}
}) => {
  const { isMobile } = useViewport()

  return <>{
    (items && items.length > 0) &&
    <div className="flex flex-wrap -mx-1 lg:-mx-2 mb-8">
      {
        items.map((item, index) => (
          <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4 relative" key={item+index}>
            <RemoveButton onClick={() => onRemove(index)} />
            <GalleryItem height={isMobile ? '66px' : '81px'} src={item}/>
          </div>
        ))
      }
    </div>
  }</>
}

export { GalleryDropzonePreview }
